import { create } from 'zustand';
import { apiClient } from '../services/api';

interface SalonOption {
  id: string;
  name: string;
}

interface SalonContextState {
  salons: SalonOption[];
  activeSalonId: string | null;
  loading: boolean;
  error: string | null;
  loadSalons: () => Promise<void>;
  setActiveSalonId: (salonId: string) => void;
  clearSalonContext: () => void;
}

const ACTIVE_SALON_STORAGE_KEY = 'visitio_active_salon_id';

export const useSalonContextStore = create<SalonContextState>((set, get) => ({
  salons: [],
  activeSalonId: localStorage.getItem(ACTIVE_SALON_STORAGE_KEY),
  loading: false,
  error: null,

  loadSalons: async () => {
    set({ loading: true, error: null });
    try {
      const res = await apiClient.get('/salons', { params: { limit: 100 } });
      const salons = (res.data?.data || []) as SalonOption[];

      let nextActive = get().activeSalonId;
      if (!nextActive || !salons.some((s) => s.id === nextActive)) {
        nextActive = salons[0]?.id || null;
      }

      if (nextActive) {
        localStorage.setItem(ACTIVE_SALON_STORAGE_KEY, nextActive);
      } else {
        localStorage.removeItem(ACTIVE_SALON_STORAGE_KEY);
      }

      set({ salons, activeSalonId: nextActive, loading: false, error: null });
    } catch {
      set({ loading: false, error: 'Nie udało się załadować salonów' });
    }
  },

  setActiveSalonId: (salonId: string) => {
    localStorage.setItem(ACTIVE_SALON_STORAGE_KEY, salonId);
    set({ activeSalonId: salonId });
  },

  clearSalonContext: () => {
    localStorage.removeItem(ACTIVE_SALON_STORAGE_KEY);
    set({ salons: [], activeSalonId: null, loading: false, error: null });
  },
}));